import $http from "@/plugins/axios.js";

export default {
  state: {
    alterWalletCards: null,
    alterWalletCard: null,
  },
  getters: {
    alterWalletCards: (state) => state.alterWalletCards,
    alterWalletCard: (state) => state.alterWalletCard,
  },
  mutations: {
    SET_ALTER_WALLET_CARDS(state, data) {
      data.alternateCard.forEach((item) => {
        item.selected = false;
      });
      state.alterWalletCards = data;
    },
    SET_ALTER_WALLET_CARD(state, data) {
      state.alterWalletCard = data;
    },
  },
  actions: {
    async getAlterWalletCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `alternatecard/?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }&used=false${
            payload.filters.type ? `&type=${payload.filters.type}` : ""
          }${payload.filters.id ? `&id=${payload.filters.id}` : ""}${
            payload.filters.email ? `&email=${payload.filters.email}` : ""
          }
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_ALTER_WALLET_CARDS", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_ALTER_WALLET_CARDS", null);
        // throw err;
      }
    },

    async getUsedAlterWalletCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);
      try {
        let res = await $http.get(
          `/alternatecard?take=${payload.take}&page=${payload.page}${
            payload.filters.startDate
              ? `&startDate=${payload.filters.startDate}`
              : ""
          }${
            payload.filters.endDate ? `&endDate=${payload.filters.endDate}` : ""
          }&used=true${
            payload.filters.type ? `&type=${payload.filters.type}` : ""
          }${payload.filters.id ? `&id=${payload.filters.id}` : ""}${
            payload.filters.email ? `&email=${payload.filters.email}` : ""
          }
          `
        );
        dispatch("toggleIsLoading", false);
        commit("SET_ALTER_WALLET_CARDS", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_ALTER_WALLET_CARDS", null);
        // throw err;
      }
    },

    async addAlterWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/alternatecard", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
    async editAlterWalletCard({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.put(`/alternatecard/${payload.id}`, payload);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        dispatch("toggleBtnLoading", false);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        throw err;
      }
    },
    async deleteAlterWalletCard({ dispatch, commit }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.delete(`/alternatecard/${id}`);
        dispatch("toggleBtnLoading", false);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم حذف البيانات بنجاح",
          duration: 3,
        });
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        return;
      }
    },
  },
};
